/* eslint-disable max-len */
import React from 'react';
function Paste() {
    return (React.createElement("g", null,
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19 3H14.82C14.4 1.84 13.3 1 12 1C10.7 1 9.6 1.84 9.18 3H5C3.9 3 3 3.9 3 5V21C3 22.1 3.9 23 5 23H19C20.1 23 21 22.1 21 21V5C21 3.9 20.1 3 19 3ZM12 3.00001C12.55 3.00001 13 3.45001 13 4.00001C13 4.55 12.55 5 12 5C11.45 5 11 4.55 11 4.00001C11 3.45001 11.45 3.00001 12 3.00001ZM5 5.00001V21H19V5.00001H17V8.00001H7V5.00001H5Z" })));
}
export default Paste;
